/**
 * Matrix Rain Effect for A*Vault Hero Section
 * Creates falling green code effect similar to The Matrix
 */

document.addEventListener('DOMContentLoaded', function() {
  const canvas = document.getElementById('matrix-canvas');
  if (!canvas) return;
  
  const ctx = canvas.getContext('2d');
  
  // Set canvas size
  function resizeCanvas() {
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
  }
  
  resizeCanvas();
  window.addEventListener('resize', resizeCanvas);
  
  // Matrix characters - mix of code symbols and mathematical notation
  const matrixChars = [
    // Programming symbols
    '0', '1', '{', '}', '[', ']', '(', ')', '<', '>', 
    '=', '+', '-', '*', '/', '%', '&', '|', '^', '~',
    ';', ':', '.', ',', '?', '!', '@', '#', '$',
    // Mathematical symbols for academic theme
    '∑', '∫', '∆', '∇', '∞', '≠', '≤', '≥', '±', '√',
    'α', 'β', 'γ', 'δ', 'ε', 'θ', 'λ', 'μ', 'π', 'σ',
    // Chemistry symbols
    'H', 'C', 'N', 'O', 'Na', 'Cl', 'Ca', 'Fe',
    // Physics symbols
    'E', 'F', 'v', 'a', 'p', 'h', 'c', 'g'
  ];
  
  // Column properties
  const fontSize = 14;
  const columns = Math.floor(canvas.width / fontSize);
  const drops = [];
  
  // Initialize drops
  for (let i = 0; i < columns; i++) {
    drops[i] = Math.random() * canvas.height;
  }
  
  // Colors for different types of content
  const colors = [
    'rgba(0, 255, 65, 0.3)',   // Classic matrix green - more transparent
    'rgba(251, 191, 36, 0.4)',  // A*Vault yellow - more transparent
    'rgba(16, 185, 129, 0.3)',  // Success green - more transparent
    'rgba(59, 130, 246, 0.3)',  // Info blue - more transparent
    'rgba(139, 92, 246, 0.3)'   // Purple accent - more transparent
  ];
  
  function draw() {
    // Create trailing effect
    ctx.fillStyle = 'rgba(15, 23, 42, 0.15)'; // Darker fade for more contrast
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    
    ctx.font = `${fontSize}px 'Courier New', monospace`;
    
    for (let i = 0; i < drops.length; i++) {
      // Choose character and color
      const char = matrixChars[Math.floor(Math.random() * matrixChars.length)];
      const colorIndex = Math.floor(Math.random() * colors.length);
      
      // Create glow effect
      ctx.shadowColor = colors[colorIndex];
      ctx.shadowBlur = 5; // Reduced glow for subtlety
      ctx.fillStyle = colors[colorIndex];
      
      // Draw character
      ctx.fillText(char, i * fontSize, drops[i]);
      
      // Reset shadow
      ctx.shadowBlur = 0;
      
      // Move drop down
      drops[i] += fontSize;
      
      // Reset drop when it reaches bottom or randomly
      if (drops[i] > canvas.height || Math.random() > 0.98) {
        drops[i] = 0;
      }
    }
  }
  
  // Animation loop
  function animate() {
    draw();
    setTimeout(() => {
      requestAnimationFrame(animate);
    }, 50); // Control speed (lower = faster)
  }
  
  animate();
  
  // Pause animation when not visible (performance optimization)
  let isVisible = true;
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      isVisible = entry.isIntersecting;
    });
  });
  
  observer.observe(canvas);
});

// Additional floating code effects
document.addEventListener('DOMContentLoaded', function() {
  // Add random glitch effects to code particles
  const codeParticles = document.querySelectorAll('.code-particle');
  
  codeParticles.forEach((particle, index) => {
    // Random delay for staggered effect
    setTimeout(() => {
      particle.style.animationDelay = `${Math.random() * 5}s`;
      
      // Occasional glitch effect
      setInterval(() => {
        if (Math.random() > 0.95) {
          particle.style.transform += ' scale(1.2)';
          particle.style.textShadow = '0 0 20px #fbbf24';
          
          setTimeout(() => {
            particle.style.transform = particle.style.transform.replace(' scale(1.2)', '');
            particle.style.textShadow = '0 0 10px rgba(0, 255, 65, 0.8)';
          }, 100);
        }
      }, 2000);
    }, index * 200);
  });
});

// Matrix-style typing effect for hero text (optional enhancement)
document.addEventListener('DOMContentLoaded', function() {
  const heroTitle = document.querySelector('.hero-title');
  if (!heroTitle) return;
  
  // Add subtle matrix glow to title on hover
  heroTitle.addEventListener('mouseenter', function() {
    this.style.textShadow = '0 0 20px rgba(251, 191, 36, 0.6), 0 0 40px rgba(251, 191, 36, 0.4)';
  });
  
  heroTitle.addEventListener('mouseleave', function() {
    this.style.textShadow = '';
  });
});